import { Tooltip } from 'antd'
import moment from 'moment'

import { EUROPEAN_DATE, EUROPEAN_DATE_WITH_HOURS_AND_MINUTES, HOURS_AND_MINUTES } from '../../../utils/constants'

const ChatMessage = ({ message, timestamp, received, username }) => {
  const now = moment()
  const time = moment(timestamp)

  const displayedTime = time.isSameOrAfter(now, 'day') ? time.format(HOURS_AND_MINUTES) : time.format(EUROPEAN_DATE)

  return (
    <div className={'message ' + (received ? 'received' : 'sent')}>
      <Tooltip title={time.format(EUROPEAN_DATE_WITH_HOURS_AND_MINUTES)} placement='right'>
        <div className='text-bubble'>
          <div className='user-and-time'> <b>{username}</b> - {displayedTime}</div>
          <div className='text'>{message}</div>
        </div>
      </Tooltip>
    </div>
  )
}

export default ChatMessage
